import { useState, useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import Link from '@/components/utils/Link';
import { URL } from '@/constants';
import { i18n } from '../DeltaAdvPC/i18n';
import { useRouter } from 'next/router';

export default function ABDS({ theme = 'black' }) {
    const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN } = URL;
    const [active, setActive] = useState(0);
    const { locale = 'us' } = useRouter();

    const {
        title,
        desc,
        item1_subtitle,
        item1_title,
        item1_desc,
        item2_subtitle,
        item2_title,
        item2_desc,
        item3_subtitle,
        item3_title,
        item3_desc,
        list1_subtitle,
        list1_title,
        list1_desc,
        tip,
    } = i18n[locale] || i18n['en'];

    let timerHandle: any;
    const getAppDataLayer = (type: string) => ({
        event: 'uaEvent',
        event_name: 'ecoflow_app',
        button_name: type,
    });

    const tabList: any = [
        {
            idx: 1,
            subTitle: item1_subtitle,
            title: item1_title,
            desc: item1_desc,
            img: require('@publicLocal/app-point/h5/ds_base_1.jpg'),
        },
        {
            idx: 2,
            subTitle: item2_subtitle,
            title: item2_title,
            desc: item2_desc,
            img: require('@publicLocal/app-point/h5/ds_base_2.jpg'),
        },
        {
            idx: 3,
            subTitle: list1_subtitle,
            title: list1_title,
            desc: list1_desc,
            img: require('@publicLocal/app-point/h5/ds_base_3.jpg'),
        },
        {
            idx: 4,
            subTitle: item3_subtitle,
            title: item3_title,
            desc: item3_desc,
            img: require('@publicLocal/app-point/h5/ds_base_4.jpg'),
        },
    ];

    useEffect(() => {
        clearInterval(timerHandle);
        timerHandle = setInterval(() => {
            setActive((active + 1) % tabList.length);
        }, 4000);

        return () => {
            clearInterval(timerHandle);
        };
    }, [active]);

    return (
        <div
            className={`${css.ABDS} app-base-ds`}
            style={{
                background: theme == 'black' ? '#000' : 'unset',
            }}
        >
            <div className={`content-wrapper ${theme}`}>
                <p className="title">{title}</p>
                <p className="desc">{desc}</p>
                <div className="img-wrapper">
                    {tabList?.map((tab: any, i: number) => (
                        <div className={`panel ${active === i ? 'active' : ''}`} key={`tab_${tab?.idx}`}>
                            <NextImage src={tab.img} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                            <div className="text-wrapper">
                                <p className="sub-title">{tab.subTitle}</p>
                                <p className="title">{tab.title}</p>
                                <p className="desc">{tab.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="tab-columns hidden-scrollbar">
                    <div className="tab-text">
                        {tabList?.map((tab: any, i: number) => (
                            <p
                                className={`tab-item ${active === i ? 'active' : ''}`}
                                key={`tab_${tab?.idx}`}
                                onClick={() => {
                                    // gtm.push({
                                    //     event: 'uaEvent',
                                    //     event_name: 'tab_click',
                                    //     button_name: tab.name,
                                    //     list_name: t('sec3_title'),
                                    // });
                                    setActive(i);
                                }}
                            >
                                {tab.subTitle}
                            </p>
                        ))}
                    </div>
                </div>
                <div className="download-wrapper">
                    <p>{tip}</p>
                    <div className="icons">
                        <Link href={APP_IOS} dataLayer={getAppDataLayer('App Store')}>
                            <NextImage src={require('@publicLocal/app-point/app_store.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                        <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                            <NextImage src={require('@publicLocal/app-point/google_play.png')} alt={'EcoFlow app'} aria-label={'EcoFlow app'} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
